import {useHistory} from 'react-router-dom'
import {sendEventToArbitration} from "@common-helpers/arbitration-helper"
import {sendToAnalytics} from './analytics'

export const setPathForRouter = (path, selectedPageId = null, closure = true, newHistory = null) => {
    const history = newHistory || useHistory(),
          landingUrl = localStorage.getItem('landing-url'),
          changeRout = () => {

              switch (landingUrl) {
                  case `custom-land`:

                  break;
                  default:

                      // if (selectedPageId < 26) {
                          sendEventToArbitration(selectedPageId, `TEST${selectedPageId}`)
                      // }

              }

              sendToAnalytics(path)
              history.push(path)
          }


    if (closure) {
        return () => changeRout()
    } else {
        changeRout()
    }

}